import React, {useContext} from 'react';
import {Navbar, Container, Nav} from 'react-bootstrap';
import NavbarLeft from './NavbarLeft';
import NavbarRight from './NavbarRight';
import AuthenticatedUserNavbar from './AuthenticatedNavbar';
import { LoadingContext, LawyerContext} from '../partials/Context';

function NavbarContent(props) {
    const lawyer = useContext(LawyerContext);
    const {photo_url} = lawyer || '';
    const {navData} = props
    const {loading} = useContext(LoadingContext)

    const {messages, sections} = navData || {};

    const [navbar_header, navbar_left, navbar_right, dropdown_menu, authenticated_user_navbar] = sections || []; 

    const {links: navbar_links} = navbar_header || [];
    const [navbar_links_obj] = navbar_links || [];
    const {href: navbar_href, src: navbar_src} = navbar_links_obj || '';
  return (
    <>
        <Navbar variant="dark"className="navbar-custom navbar-inverse" id="navbar" expand="md">
                <Container>
                    <Navbar.Brand href={navbar_href} className="navbar-header">
                        <img src={navbar_src} alt='Specprawnik.pl'/>
                    </Navbar.Brand>
                    <Navbar.Toggle aria-controls="basic-navbar-nav" />
                    <Navbar.Collapse id="basic-navbar-nav sp-navbar-collapse-1">
                        <Nav className="me-auto">
                            <NavbarLeft left_links={navbar_left}
                            loading={loading} />
                            <NavbarRight
                            messages={messages} 
                            right_links={navbar_right}
                            loading={loading}
                            dropdown_menu_links={dropdown_menu}
                            lawyer_img={photo_url}
                            />
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
            <AuthenticatedUserNavbar 
                links={authenticated_user_navbar}
                messages={messages}
            /> 
            </>
  )
}

export default NavbarContent